import React, { Component } from 'react';
import Header from '../header'
import Footer from '../footer'
//import PageLoading from './common/loaders/pageLoading'

export default class MainLayout extends Component {
    constructor(props){
        super(props);
        this.state = {
            showLoading : true
        }
    }
    componentWillMount(){
        this.setState({
            showLoading : true
        })
    }
    componentDidMount(){
        this.setState({
            showLoading : false
        })
    }
    render() {
        return (
            <div>
                {
                    //<PageLoading visibilityProp={this.state.showLoading}/>
                }
                <div className="headerInMain">
                    <Header/>
                </div>

                <div className="bodyInMain">
                    <div>
                        {this.props.children}
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}
